import React from 'react';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { DashboardDocument } from "components/resources/dashboards/DashboardDocument";
import APIRequest, { APIError } from 'system/APIRequest';
import withOptionsWidget from 'components/widgetParts/withOptionsWidget';
import { currentUser } from 'system/InfegyUser';
import { TemplateQueryProps, TemplateSearchContent } from './TemplateSearchContent';

export function TemplateSearchWidgetContent(): JSX.Element {
  const user = currentUser();

  const canSubmitQueries = user?.permissions?.includes("run_query");

  const [fieldIds, setFieldIds] = useState<string[]>([]);
  const [useDefaults, setUseDefaults] = useState<boolean>(true);
  const [templateQueries, setTemplateQueries] = useState<TemplateQueryProps[]>([]);
  const [dashboard, setDashboard] = useState<DashboardDocument | undefined>(undefined);
  const [globalStartDate, setGlobalStartDate] = useState<string | undefined>(undefined);
  const [globalEndDate, setGlobalEndDate] = useState<string | undefined>(undefined);

  // When first loading the widget, check local storage for the last widget settings and apply them
  // Note: Settings here are stored in local storage rather than the widget data so that
  // different users of the same query form can have different query history, and so that
  // users of a shared dashboard query form can save prior settings for a widget they can't modify
  useEffect(() => {
    const lastTemplateSearchSettings = localStorage.getItem("lastTemplateSearchSettings");

    if (!templateQueries?.length) {
      if (lastTemplateSearchSettings) {
        const settings = JSON.parse(lastTemplateSearchSettings);
        const dashboardId = settings.dashboardId || settings.selectedDashboardOption?.id;

        let templateQueries = settings.templateQueries;
        if (!Array.isArray(templateQueries) || templateQueries.length === 0) {
          templateQueries = [new TemplateQueryProps(user)];
        }
        // Load the selected dashboard and field ids from the last settings
        APIRequest(`obj/dashboard/${dashboardId}`, {}, {
          method: "GET"
        }).then((response: any) => {
          setDashboard(response.output as DashboardDocument);
          setFieldIds(settings.fieldIds);
          setGlobalStartDate(settings.globalStartDate);
          setGlobalEndDate(settings.globalEndDate);
          setTemplateQueries(templateQueries);
        }).catch((error: APIError) => {
          localStorage.removeItem("lastTemplateSearchSettings");
          setTemplateQueries([new TemplateQueryProps(user)]);
        });
      } else {
        setTemplateQueries([new TemplateQueryProps(user)]);
      }
    }
  }, [templateQueries?.length]);

  return (
    <Box sx={{ maxHeight: "100%", display: "grid", gridTemplateRows: "auto 1fr auto", overflowY: "auto" }}>
      {canSubmitQueries && templateQueries?.length > 0 &&
        <TemplateSearchContent
          dashboard={dashboard}
          setDashboard={setDashboard}
          templateQueries={templateQueries}
          setTemplateQueries={setTemplateQueries}
          globalStartDate={globalStartDate}
          setGlobalStartDate={setGlobalStartDate}
          globalEndDate={globalEndDate}
          setGlobalEndDate={setGlobalEndDate}
          fieldIds={fieldIds}
          setFieldIds={setFieldIds}
          useDefaults={useDefaults}
          setUseDefaults={setUseDefaults}
          showDashboardSelector={true}
          />
        }
    </Box>
  );
}

export default withOptionsWidget(TemplateSearchWidgetContent, { hasSettingsDialog: false });